import axios from "axios";
import ConstantList from "../appConfig";
const API_PATH = ConstantList.API_EN_POINT + "/profession";

export const getAllProfession = () => axios.get(API_PATH + "/get-all-profession");

export const pagingProfession = (searchObject) => axios.post(API_PATH + "/search-by-page", searchObject);

export const getProfessionById = (professionId) => axios.get(API_PATH + "/get-by-id/" + professionId);

export const saveProfession = profession => axios.post(API_PATH + '/save-or-update', profession);

export const deleteProfession = professionId => axios.delete(API_PATH + '/mark-delete/' + professionId);